function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.6708,
  cy: 13.0001,
  rx: 13.6708,
  ry: 12.9999,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8013 21.2005V14.0008H17.3848L17.7716 11.195H14.8013V9.40356C14.8013 8.5912 15.0425 8.03759 16.2879 8.03759L17.8762 8.03694V5.52744C17.6014 5.49323 16.6586 5.41683 15.5617 5.41683C13.2716 5.41683 11.7039 6.72441 11.7039 9.12578V11.195H9.11377V14.0008H11.7039V21.2005H14.8013Z",
  fill: "#20205E"
});

var SvgFbWhite = function SvgFbWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFbWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb-white.2ca15289.svg";
export { ForwardRef as ReactComponent };